/**
 * Single source for day-of-week names/order — matches the backend convention
 * (batch_management.py: 0=Monday … 6=Sunday). Replaces 3 independently
 * defined arrays (BatchDashboard.js, BatchScheduleReport.js,
 * StudentEnrollment.js) that had drifted from each other — one started the
 * week on Sunday, another omitted Sunday entirely.
 */
export const DAY_NAMES_FULL  = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
export const DAY_NAMES_SHORT = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
